import Button from "src/components/general/buttonv3";
import SvgIcon from "components/general/svgIcon";
import { downloadLinksArray } from "data/variables";

const FooterPersonalPrice = () => {
  return (
    <div className="w-full px-4 py-10 sm:py-16 md:py-20">
      <div className="mx-auto max-w-xs sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl">
        <div className="overflow-hidden rounded-xl bg-gradient-to-r from-purple-100 to-blue-400 p-[2px]">
          <div className="flex h-full flex-col rounded-xl bg-brand-slate p-6 sm:p-8 md:flex-row md:items-center md:justify-between">
            <div className="mb-6 text-center md:mb-0 md:text-left">
              <span className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                Connect. Manage.
              </span>
              <br />
              <span className="mt-1 bg-gradient-to-r from-purple-100 to-blue-400 bg-clip-text font-bold text-2xl text-transparent sm:text-3xl md:text-4xl lg:text-5xl">
                Redact.
              </span>
            </div>
            <div className="flex flex-col items-center md:ml-0">
              <Button
                isDisabled={false}
                buttonText="Create account!"
                buttonURL="/account"
                color="primary"
                size="md"
              />

              <div className="mt-4 flex space-x-4">
                {downloadLinksArray.map((value) => (
                  <a
                    className="transition-transform hover:scale-110"
                    href={value.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={String(value.icon) + value.link}
                    aria-label={`Download for ${value.icon}`}
                  >
                    <SvgIcon name={value.icon} className="h-6 w-6 fill-white text-white" />
                  </a>
                ))}
              </div>

              <p className="mt-3 text-center font-light text-sm text-white/80">
                Available on Windows, MacOS, and Linux Today
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterPersonalPrice;
